<template>
  <div class="row" v-if="canRead">
    <div class="col-md-12">
      <card>
        <button v-if="showActionButton" @click="actionButtonAction" type="button" class="btn btn-fill btn-info" style="float: right; margin-top: -4px;">
          {{ actionButtonText }}
        </button>
        <tabs @activated="tabActivated" value="InspectorApp" tab-content-classes="text-center" ref="inspectorAppTabs">
          <tab-pane title="Digital Form" key="digitalForm" id="digital-form" ref="digitalForm">
            <digital-form></digital-form>
          </tab-pane>
          <tab-pane title="Search Comments" key="comments" id="inspector-app-comments" ref="comments">
            <comments></comments>
          </tab-pane>
          <tab-pane title="Form Fields" key="fields" id="inspector-app-fields" ref="formFields">
            <form-fields></form-fields>
          </tab-pane>
          <tab-pane title="Form Field Blocks" key="fields-blocks" id="inspector-app-field-blocks">
            <form-field-blocks ref="formFieldBlocks"></form-field-blocks>
          </tab-pane>
          <tab-pane title="Tags" key="tags" id="inspector-app-tags" ref="tags">
            <tags></tags>
          </tab-pane>
        </tabs>
      </card>
    </div>
  </div>
</template>

<script>
  import Permissions from 'src/utilities/permissions'
  import {Tabs, TabPane, Card} from 'src/components/UIComponents'
  import Comments from './Comments'
  import DigitalForm from './DigitalForm'
  import Tags from './Tags'
  import FormFields from './FormFields'
  import FormFieldBlocks from './FormFieldBlocks'

  export default {
    components: {
      Card,
      Comments,
      DigitalForm,
      FormFields,
      FormFieldBlocks,
      Tags,
      Tabs,
      TabPane
    },
    data() {
      return {
        activeTab: 'Digital Form'
      }
    },
    methods: {
      async tabActivated(whichTab) {
        this.activeTab = whichTab
      },
      actionButtonAction() {
        switch (this.activeTab) {
          case 'Form Fields':
            this.$eventHub.$emit('show-modal-1', 'Form Field', null, '600px')
            break
          case 'Form Field Blocks':
            this.$eventHub.$emit('show-modal-1', 'Form Field Block', null, '600px')
            break
          case 'Tags':
            this.$eventHub.$emit('show-modal-1', 'Tag', null, '400px')
        }
      }
    },
    computed: {
      showActionButton() {
        // show for all tabs except digitalForm and Comments
        return this.activeTab !== 'Digital Form' && this.activeTab !== 'Search Comments'
      },
      actionButtonText() {
        switch (this.activeTab) {
          case 'Form Fields':
            return 'Add Form Field';
          case 'Form Field Blocks':
            return 'Add Form Field Block';
          case 'Tags':
            return 'Add Tag'
        }

        return ''
      },
      canRead() {
        return this.$can('read', Permissions.INSPECTOR_APP)
      },
      canEdit() {
        return this.$can('edit', Permissions.INSPECTOR_APP)
      }
    }
  }
</script>

<style scoped>
</style>
